<div class="container">
    <div class="header_calculator" style="padding: 12px 15px;">
        <p class="text_prices">
            {{'buy_sell_detail.market_price'|translate}}:
            <span class="number price-calculator" *ngIf="isOutSidePage === true">{{getCurrency(userData.preferredCurrency.shortName).symbol}}{{(markerPrice * getCurrency(userData.preferredCurrency.shortName).value)|number: (selectedCoinShortName=='XRP'?'1.3-3': '1.2-2')}}</span>
            <span class="number price-calculator"  *ngIf="isOutSidePage === false">${{selectedCoin.priceUsd}}</span>
        </p>
        <a href=" javascript:void(0)" (click)="clearInput()"><span><i style="color: #000; font-size: 15px;"
                        class="fas fa-trash"></i></span></a>
    </div>
    <div class="row row__design">
        <div class="col-sm-12 col-md-6 col-lg-6">
            <div class="element__1">
                <div class="input-group">
                    <input type="text" class="form-control currency" id="coinAmount" name="amount"
                        (click)="focusInput('coinAmount')"
                        [placeholder]="selectedCoin.shortName? selectedCoin.shortName: ''"
                        [value]="(sliceAmount.sliceValueTo8Digit(focusCurrencyAmount?((currencyVal.amountCurrency / (currencyValue * markerPrice))|| 0): valueCoin))|number:'1.0-8'"
                        [ngModel]="calculator.amount" (input)="updateAmount()" autocomplete="none" maxlength="15"
                        #firtInputValue>
                        {{checkCalculatorFocus()}}
                    <div class="input-group-control" id="coinsFilter">
                        <div class="form-group whit_b whit_bb1 choosePayment choosePaymentDiv">
                            <div class="choosePayment" style="float: right;">
                                <span class="currency-select inputClass choosePayment cursorPointer" id="coinsSpan"
                                    style="display: inline-flex; padding: 6px;" (click)="getCoins()">
                                    <div class="chooseType2 cursorPointer" id="coinsValue" style="display: inline-flex">
                                        <img height="25" width="auto" class="cursorPointer" id="coinsImg"
                                            [src]="selectedCoin.imageUrl || '#'" alt="" />
                                        <div style="padding: 6px" id="coinsDiv">
                                            {{selectedCoin.shortName}}</div>
                                    </div>

                                </span>

                                <span (click)="getCoins()" style="top: auto; left: auto; right: auto;"><i id="coinsImg"
                                        [ngClass]="coinsListFilter && coinsListFilter.length?'fa-angle-up':'fa-angle-down'"
                                        class="fa  fa_dwn textcolor chooseTypeIcon cursorPointer"
                                        aria-hidden="true"></i></span>
                            </div>
                        </div>
                        <div [ngClass]="isFilterDrop? ('drop_down drop_down1 choosePayment  chooseCurrencyDropNew'):('drop_down drop_down2 choosePayment  chooseCurrencyDrop')"
                            id="coinsDrop" *ngIf="coinsListFilter && coinsListFilter.length">
                            <ul class="drop_menu boxs choosePaymentType" style="min-width: calc(100% - 30px)">
                                <li *ngFor="let c of coinsListFilter;">
                                    <a href="javascript:void(0)" (click)="setCoinFilter(c)" class="active textcolor"
                                        style="display: inline-flex; width: 100%;">
                                        <img height="25" width="auto" class="cursorPointer" [src]="c.imageUrl" alt="" />
                                        <div style="padding: 5px 20px"> {{c.fullName}} - {{c.shortName}}</div>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-6">
            <div class="element__1">
                <div class="input-group">
                    <input type="text" id="currencyAmount" class="form-control currency" [placeholder]="buySellCurrency"
                        (click)="focusInput('currencyAmount')"
                        [value]="(sliceAmount.sliceValueTo8Digit(focusCoinAmount?(((markerPrice * calculator.amount) * currencyValue) || 0): 0))|number:'1.0-2'"
                        name="amountCurrency" (input)="updateAmountCurrency()"
                        maxlength="15" #secondInput autocomplete="none">
                    <div class="input-group-control">
                        <div class="form-group whit_b whit_bb1 choosePayment choosePaymentDiv">
                            <div class="choosePayment" style="float: right;">
                                <span class="currency-select inputClass choosePayment cursorPointer" id="currencySpan"
                                    style="display: inline-flex; padding: 6px;" (click)="getCurrencyList()">
                                    <div class="chooseType2 cursorPointer" id="currencyOrderValue"
                                        style="display: inline-flex">
                                        <div style="padding: 6px" id="currencyDiv">
                                            {{buySellCurrency}}</div>
                                    </div>
                                </span>
                                <span (click)="getCurrencyList()" style="top: auto; left: auto; right: auto;"><i
                                        id="currencyOrderImg"
                                        [ngClass]="currenciesList && currenciesList.length?'fa-angle-up':'fa-angle-down'"
                                        class="fa  fa_dwn textcolor chooseTypeIcon cursorPointer"
                                        aria-hidden="true"></i></span>
                            </div>
                        </div>
                    </div>
                    <div [ngClass]="isFilterDrop? ('drop_down drop_down1 choosePayment  chooseCurrencyDropNew') : ('drop_down drop_down2 choosePayment  chooseCurrencyDrop')"
                        id="currencyOrderDrop" *ngIf="currenciesList && currenciesList.length">
                        <ul class="drop_menu boxs choosePaymentType" style="min-width: calc(100% - 30px)">
                            <li *ngFor="let c of currenciesList;">
                                <a href="javascript:void(0)" (click)="setCurrencyOrder(c)" class="active textcolor">
                                    <i
                                        class="bit_para">{{c? c['fullName'+(language=='en'?'':(language.toUpperCase()))]: '' }}</i></a>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>
        </div>
      <div class="element__2 col-sm-12 col-md-12 col-lg-12">
        <ul class="coinListImg">
          <li *ngFor="let c of coinList" (click)="setCoinFilter(c)">
            <div href="#">
              <img height="23px" width="auto" [src]="c.imageUrl" alt="">
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="row row-design openOption">
        <div class="col">
            <div class="tablewrpr">
                <div class="row">
                    <div class="col-12">
                        <div style="margin-top: 2px;">
                            <table class="display nowrap dataTableCalculator table-hover table">
                                <thead>
                                    <tr>
                                        <th class="text-left align-middle">
                                            {{'buy_sell_detail.coin_calculator'|translate}}</th>
                                        <th class="text-center align-middle">
                                            {{'buy_sell_detail.coin_conversion_calculator'|translate}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let i of coinList">
                                        <td class="text-left align-middle">
                                            <div class="text-box">
                                                <img [src]="i.imageUrl" alt="coin-image" height="20px" width="auto" />
                                                <span class="ml-3">
                                                    {{i.fullName}} - {{i.shortName}}</span>
                                            </div>
                                        </td>

                                        <td *ngIf="i.shortName == selectedCoin.shortName" class="text-center currency">
                                            <!-- {{(focusCurrencyAmount
                                                ?
                                                ((currencyVal.amountCurrency / (currencyValue * markerPrice))|| 0)
                                                :
                                                 (((markerPrice * calculator.amount) * currencyValue) || 0))|number:'1.0-8'}} -->

                                                 {{(focusCurrencyAmount ? ((currencyVal.amountCurrency / (currencyValue * markerPrice))|| 0) :(calculator.amount || 0)) |number:'1.0-8'}}
                                        </td>
                                        <td  *ngIf="i.shortName != selectedCoin.shortName" class="text-center currency">
                                            {{(focusCoinAmount?((markerPrice * calculator.amount)/i.priceUsd):(currencyVal.amountCurrency / (currencyValue * i.priceUsd))) || 0|number: '1.0-8'}}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
